import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const yasminaRoute = createMetaRoute<RouteMeta>();
